module.exports = __webpack_public_path__ + "img/offer.9517bea9.png";